module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/fineFragrance_fb337b.png";